import styled from 'styled-components';

export const Container = styled.div`
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  max-width: 744px;
  color: #161d1f;
`;

export const ContainerBtnCancel = styled.div`
  display: grid;
  justify-content: center;
  @media (min-width: 640px) {
    justify-content: left;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    max-width: 744px;
  }
`;
